const Iot = {
	state: {
		terminal: [],
		devices: null,
		device: {
			unit: null
		},
		devicesdata1: {
			id: null
		},
		devicesdata2: {
			id: null
		},
		abnormal: null,
		Aerationoperate: {
			terminalId: null
		}
	},
	mutations: {
		terminal(state,value)
		{
			state.terminal=value;
		},
		devices(state,value)
		{
			state.devices=value;
		},
		device(state,value)
		{
			state.device=value;
		},
		devicesdata1(state,value)
		{
			state.devicesdata1=value;
		},
		devicesdata2(state,value)
		{
			state.devicesdata2=value;
		},
		abnormal(state,value)
		{
			state.abnormal=value;
		},
		Aerationoperate(state,value)
		{
			state.Aerationoperate=value;
		}
	},
	actions: {
		
	},
	getters: {
		EXmenu: state=>{
			let menu=state.terminal.map(value=>{
				return{
					id: value.id,
					name: value.name,
					icon: "my-icon-zhd",
					link: "anomaly",
					select: false,
					submenu: []
				}
			});
			return menu;
		}
	}
};
export default {
	namespaced: true,
	Iot
};
